import { DateTime } from "luxon"

import KPITable from "@/components/KPITable"
import ForHireHeader from "@/features/balance-map/components/ForHireHeader"
import KPIChartGroup from "@/features/dashboards/components/KPIChartGroup"
import ForHireLiveMetrics from "@/features/logistics/components/ForHireLiveMetrics"

export default function ForHire() {
  const asOf = DateTime.now()
    .setZone("America/Chicago")
    .minus({ days: 1 })
    .startOf("day")
    .toJSDate()

  return (
    <div>
      <ForHireHeader />
      <div className="w-full flex flex-col xl:flex-row gap-4">
        <div className="flex flex-col grow-1 gap-2">
          <ForHireLiveMetrics />
          <div className="rounded-md shadow-sm border">
            <KPITable
              request={{
                returnSize: 7,
                aggType: "Daily",
                kpis: [
                  {
                    $type: "basic",
                    id: 400,
                  },
                  {
                    $type: "basic",
                    id: 401,
                  },
                  {
                    $type: "calc",
                    expression: "100 * [461] / ([401]*2)",
                    name: "Truck Utilization",
                    unit: "%",
                    preAggregate: true,
                  },
                  {
                    $type: "calc",
                    expression: "[500]/[401]",
                    name: "Revenue/Truck/Day",
                    unit: "$",
                    preAggregate: true,
                    aggFunction: "Sum",
                  },
                  {
                    $type: "basic",
                    id: 430,
                  },
                  {
                    $type: "basic",
                    id: 440,
                  },
                  {
                    $type: "calc",
                    expression: "[440]*(1010/909.4)/8",
                    name: "Fuel Consumption",
                    unit: "MMBtu",
                    preAggregate: true,
                    aggFunction: "Sum",
                  },
                ],
              }}
              showAverage={false}
            />
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <KPIChartGroup
            request={{
              asOf,
              returnSize: 30,
              aggType: "Daily",
              kpis: [
                {
                  $type: "basic",
                  id: 500,
                  aggFunction: "Sum",
                },
                {
                  $type: "basic",
                  id: 450,
                  aggFunction: "Sum",
                },
              ],
            }}
          />
        </div>
      </div>
    </div>
  )
}
